export default "__VITE_ASSET__HdV3MQB3__"